// Generated by packages/glyph-decoder/scripts/generate-regular-atlases.ts.
// Source: data/regular-glyph-atlas (cleartype-bgr, black text on white).
// Do not edit manually; run `npm run generate:regular-atlases`.
export const RAW_GLYPHS = [
    {
        char: " ",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "!",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAALtmALtmAIhmAIhmAIhEAGZEAGZEAAAAALtmAAAAAAAA",
    },
    {
        char: "\"",
        width: 4,
        anchorKey: "\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAACK7IrsiuyK7AIgAiAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "#",
        width: 7,
        anchorKey: "\u0000\u0248XHHHH",
        weightsB64: "AAAAAAAAAAAAAESIAGZmAAAAZmYAiEQAZv///////yIAAP8AIrsAAAAiuwBEiAAAZv///////yIAZmYAiEQAAAC7IgC7IgAAAP8AIrsAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "$",
        width: 7,
        anchorKey: "\u0000\u0080\u0002\u0222\u0222\u0000\u0000",
        weightsB64: "AAAAAAAAAAAA////iAAAu2ZmIohEALsiZiIAAACIiGYiAAAAAET//7sAAAAAZiKIiAD/AGYiRLsAiGZmIohmAAC7//+IAAAAAGYiAAAAAAAAAAAA",
    },
    {
        char: "%",
        width: 11,
        anchorKey: "\u0000\b\"\"\u0000\u0000\u0010\u0004\u0220\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAARP//IgAAZogAAAC7IkS7AAD/AAAAAP8AIrsAZmYAAAAAuyJEuyL/AAAAAABE//8iiESI/7sAAAAAACK7IrsAiGYAAAAAiEREiABmZgAAACK7ACK7AIhmAAAAuyIAAIj/uwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "&",
        width: 8,
        anchorKey: "\u0000\u0080\u020c\u0222\u0252\u018c\u0180\u0000",
        weightsB64: "AAAAAAAAAAAAAET//0QAAAAA/yIi/wAAAAD/IiL/AAAAAGa7/0QAAAAAu/+IAAAAALtEAP9miGYi/wAAIv//AAC7RAAA//8iAAD///9ERLsAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "'",
        width: 2,
        anchorKey: "\u0000\u0000",
        weightsB64: "AAAiuyK7IogAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "(",
        width: 4,
        anchorKey: "\u0000@\u0000\u0000",
        weightsB64: "AAAAAAAAIrsAALsiAESIAACIRAAAuyIAAP8iAAC7IgAAiEQAAESIAAAAuyIAACK7",
    },
    {
        char: ")",
        width: 4,
        anchorKey: "\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAAAC7IgAAIrsAAACIRAAARIgAACK7AAAiuwAAIrsAAESIAACIRAAiuwAAuyIA",
    },
    {
        char: "*",
        width: 5,
        anchorKey: "\u0000\u0004\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAGZEACL/iIiIAAC7ZgAAiESIRAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "+",
        width: 7,
        anchorKey: "\u0000     \u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAiEQAAAAAAIhEAAAA//////+7AAAAiEQAAAAAAIhEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ",",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALtEAEREAGYA",
    },
    {
        char: "-",
        width: 4,
        anchorKey: "\u0000@@@",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARP///wAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ".",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALtEAAAAAAAA",
    },
    {
        char: "/",
        width: 3,
        anchorKey: "\u0000\u0080\b",
        weightsB64: "AAAAAAAAZmYAALsiAAD/AABEiAAAZmYAALsiAAD/AABEiAAAZmYAAAAAAAAAAAAA",
    },
    {
        char: "0",
        width: 7,
        anchorKey: "\u0000 \u0000\u0202\u0202\u0104\u0000",
        weightsB64: "AAAAAAAAAAAAiP//IgAAZogAIv8AAIhEAAC7RAC7IgAAiGYA/yIAAIhmALsiAACIZgCIRAAAu0QAZrsAIv8AAACI//8iAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "1",
        width: 7,
        anchorKey: "\u0000\u0000\b\u0004\u0004\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAC7RAAAAAD//0QAAET/ZrtEAAAAAAC7RAAAAAAAu0QAAAAAALtEAAAAAAC7RAAAAAAAu0QAAAAAALtEAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "2",
        width: 7,
        anchorKey: "\u0000\u0208\u0200\u0202\u0202\u0200\u0000",
        weightsB64: "AAAAAAAAAAAAu///iAAAiGYAALtmAP8AAABEiAAAAAAAiGYAAAAAZrsAAAAAiLsAAAAAu4gAAAAAu4gAAAAAIv//////iAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "3",
        width: 7,
        anchorKey: "\u0000\u0100\u0202\u0202\u0222\u0014\u0000",
        weightsB64: "AAAAAAAAAAAA////RAAAu0QAIv8AAAAAAAC7RAAAAAAi/wAAAAC7/2YAAAAAAACIZgAAAAAARIgA/yIAAIhmACL///9mAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "4",
        width: 7,
        anchorKey: "\u0000\u0080\u0080\u0080\u0084\u0080\u0000",
        weightsB64: "AAAAAAAAAAAAAABmiAAAAAAi/4gAAAAAu4iIAAAAZmZmiAAAIrsAZogAALsiAGaIACL//////7sAAAAAZogAAAAAAGaIAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "5",
        width: 7,
        anchorKey: "\u0000\u0100\u0212\u0212\u0212\u0002\u0000",
        weightsB64: "AAAAAAAAAAAi/////0QARIgAAAAAAGZmAAAAAACI////iAAAu2YAAGZmAAAAAABEiAAAAAAARIgA/yIAAGZEACL///9mAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "6",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\u0212\u0212\u0004\u0000",
        weightsB64: "AAAAAAAAAAAAZv//ZgAARIgAAP8iAIhEAAAAAAC7Zv//ZgAAu4gAALsiALsiAACIZgCIIgAAiGYARIgAALsiAACI//9EAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "7",
        width: 7,
        anchorKey: "\u0000\u0002\u0002B\u0012\u0006\u0000",
        weightsB64: "AAAAAAAAACL//////4gAAAAAAP8iAAAAAIhmAAAAACL/AAAAAACIZgAAAAAA/yIAAAAARLsAAAAAAGZmAAAAAACIZgAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "8",
        width: 7,
        anchorKey: "\u0000\u0080\u0200\u0222\u0222\u0154\u0000",
        weightsB64: "AAAAAAAAAAAAu///RAAAiGYAIv8iALsiAACIRACIZgAi/yIAAIj//yIAALtmAAD/RAD/IgAAiGYAu2YAAP9EAAD///9mAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "9",
        width: 7,
        anchorKey: "\u0000\u0000\u0200\u0242\u0202\u0124\u0000",
        weightsB64: "AAAAAAAAAAAAu///RAAAiIgAIv8iALsiAACIZgC7IgAAiGYAiIgAIv9mAAC7/7tmZgAAAAAAiEQAiGYAIv8AAAD///8iAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ":",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAALtEAAAAAAAAAAAAAAAAAAAAALtEAAAAAAAA",
    },
    {
        char: ";",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAALtEAAAAAAAAAAAAAAAAAAAAALtEAEREAGYA",
    },
    {
        char: "<",
        width: 7,
        anchorKey: "\u0000 \u0000PP\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7iAAAZv//IgAA/2YAAAAAAABm//8iAAAAAAAAu4gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "=",
        width: 7,
        anchorKey: "\u0000\u0090\u0090\u0090\u0090\u0090\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//////4gAAAAAAAAAAAAAAAAAAAD//////4gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: ">",
        width: 7,
        anchorKey: "\u0000\u0088\u0000PP\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAP9mAAAAAAAAZv//IgAAAAAAALuIAABm//8iAAD/ZgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "?",
        width: 7,
        anchorKey: "\u0000\b\u0000\u0002\u0002\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAu///iAAAiIgAALtmAP8iAABEiAAAAAAAZmYAAAAAiLsAAAAAZogAAAAAALtEAAAAAAAAAAAAAAAAuyIAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "@",
        width: 12,
        anchorKey: "\u0000\u00c0\u0400\u0804\u0220\u0212\u0012\u0102\u0212\u0004\b\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAIj/////AAAAAAAi/4gAAABE/0QAAAC7RAAAAAAAIv8AAGaIAET//2b/AIhmALtEIv8AAIi7AGaIAP8iiGYAAGZmAGZmAP8AuyIAAIhEALsiALsiiGYARP8iiIgAAIhmAP//iLv/iAAAACL/IgAAAAAAAGaIAABm/2YAAAAAu7sA",
    },
    {
        char: "A",
        width: 7,
        anchorKey: "\u0000\u0000@@@`\u0100",
        weightsB64: "AAAAAAAAAAAAAACIZgAAAAAAAIi7AAAAAABmZogiAAAAALsiRIgAAAAiuwAA/wAAAGb/////RAAAuyIAAESIACKIAAAAAP8AZkQAAAAAiGYAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "B",
        width: 8,
        anchorKey: "\u0000\u0000\u0222\u0222\u0222\u0222 \u0000",
        weightsB64: "AAAAAAAAAAAAu/////+IAAC7RAAAALtmALtEAAAAZmYAu0QAAAC7IgC7//////8iALtEAAAAZogAu0QAAABEiAC7RAAAAIhmALv/////iAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "C",
        width: 9,
        anchorKey: "\u00000\u0104\u0202\u0202\u0202\u0202\u0104\u0000",
        weightsB64: "AAAAAAAAAAAAAAAA/////yIAACL/RAAARP8iAIhmAAAAAGaIAP8iAAAAAAAAAP8AAAAAAAAAALsiAAAAAAAAAIhmAAAAAGaIACL/RAAARP8iAAAA/////yIAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "D",
        width: 9,
        anchorKey: "\u0000\u0000\u0202\u0202\u0202\u0202\u0000\u0080\u0000",
        weightsB64: "AAAAAAAAAAAAALv/////iAAAALtEAAAAiIgAALtEAAAAALsiALtEAAAAAIhmALtEAAAAAGZmALtEAAAAAIhmALtEAAAAAP8iALtEAAAAiIgAALv/////iAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "E",
        width: 8,
        anchorKey: "\u0000\u0000\u0222\u0222\u0222\u0222\u0222\u0000",
        weightsB64: "AAAAAAAAAAAAu///////ZgC7RAAAAAAAALtEAAAAAAAAu0QAAAAAAAC7//////8iALtEAAAAAAAAu0QAAAAAAAC7RAAAAAAAALv//////4gAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "F",
        width: 7,
        anchorKey: "\u0000\u0000\"\"\"\"\u0000",
        weightsB64: "AAAAAAAAAAC7/////7sAu0QAAAAAALtEAAAAAAC7RAAAAAAAu/////8AALtEAAAAAAC7RAAAAAAAu0QAAAAAALtEAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "G",
        width: 9,
        anchorKey: "\u0000\u0000\u0104\u0002\u0202\u0202\u0242\u0140\u0000",
        weightsB64: "AAAAAAAAAAAAAAAA/////wAAAAD/RAAAZrsAAGaIAAAAALsiALtEAAAAAAAAALsiAAAAAAAAALtEAAC7//9mAGaIAAAAAIhmAAD/ZgAAAP9mAAAAu////0QAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "H",
        width: 9,
        anchorKey: "\u0000\u0000      \u0000",
        weightsB64: "AAAAAAAAAAAAALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEALv///////9EALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "I",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAALtEALtEALtEALtEALtEALtEALtEALtEALtEAAAAAAAA",
    },
    {
        char: "J",
        width: 6,
        anchorKey: "\u0000\u0200\u0200\u0200\u0100\u0000",
        weightsB64: "AAAAAAAAAAAAALtEAAAAALtEAAAAALtEAAAAALtEAAAAALtEAAAAALtEAAAAALtEiGYAAP8iAP///2YAAAAAAAAAAAAAAAAA",
    },
    {
        char: "K",
        width: 8,
        anchorKey: "\u0000\u0000\u0000  \u0000\u0100\u0202",
        weightsB64: "AAAAAAAAAAAAALtEAAAAZv8AALtEAABmiAAAALtEAGaIAAAAALtEZogAAAAAALu7//8AAAAAALu7AIi7AAAAALtEAAC7ZgAAALtEAAAi/yIAALtEAAAAZv8iAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "L",
        width: 7,
        anchorKey: "\u0000\u0000\u0200\u0200\u0200\u0200\u0200",
        weightsB64: "AAAAAAAAAAC7RAAAAAAAu0QAAAAAALtEAAAAAAC7RAAAAAAAu0QAAAAAALtEAAAAAAC7RAAAAAAAu0QAAAAAALv//////wAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "M",
        width: 9,
        anchorKey: "\u0000\u0000\u0002\u0000\u0100\u0000\u0000\u0002\u0000",
        weightsB64: "AAAAAAAAAAAAALv/AAAARP9EALu7IgAAiLtEALuIZgAAiLtEALtEiAAiZrtEALtEuwBmRLtEALtEZiKIALtEALtERGa7ALtEALtEAP9mALtEALtEALtEALtEAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "N",
        width: 9,
        anchorKey: "\u0000\u0000\u0004\b\u0000\u0000\u0000\u0300\u0000",
        weightsB64: "AAAAAAAAAAAAALuIAAAAALtEALv/RAAAALtEALtE/wAAALtEALtERIgAALtEALtEAIgiALtEALtEACK7ALtEALtEAABmZrtEALtEAAAAu/9EALtEAAAAIv9EAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "O",
        width: 9,
        anchorKey: "\u0000p\u0104\u0202\u0202\u0202\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAi////iAAAACL/IgAAiLsAAIhEAAAAALtEAP8iAAAAAGaIAP8AAAAAAESIAP8AAAAAAGaIAIhEAAAAALtEACL/RAAAiLsAAAAA////iAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "P",
        width: 8,
        anchorKey: "\u0000\u0000\"\"\"\"\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAu/////+7AAC7RAAAAIhmALtEAAAAZogAu0QAAAC7ZgC7/////4gAALtEAAAAAAAAu0QAAAAAAAC7RAAAAAAAALtEAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Q",
        width: 9,
        anchorKey: "\u0000p\u0104\u0202\u0202\u0202\u0100\u0208\u0000",
        weightsB64: "AAAAAAAAAAAAAAAi////iAAAAET/IgAAiIgAALtEAAAAAP8iAP8AAAAAAIhmIv8AAAAAAGZmAP8AAAAAAIhmALtEAABmALsiACL/IgCI/4gAAAAi////RP+7AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "R",
        width: 9,
        anchorKey: "\u0000\u0000\"\"\"b\u00a2\u0114\u0000",
        weightsB64: "AAAAAAAAAAAAALv//////0QAALtEAAAAIv8iALtEAAAAALtEALtEAAAAIv8iALv//////yIAALtEAAD/ZgAAALtEAAAi/0QAALtEAAAAZv8AALtEAAAAALu7AAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "S",
        width: 8,
        anchorKey: "\u0000\u0080\u0010\u0222\u0222\u0222\u0004\u0000",
        weightsB64: "AAAAAAAAAAAAAIj///9EAACIiAAAIv8iALtEAAAAiGYAZv8iAAAAAAAAAP///2YAAAAAAAAAu2YA/wAAAABEiACIiAAAAIhmAACI////ZgAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "T",
        width: 7,
        anchorKey: "\u0000\u0002\u0002\u0002\u0002\u0002\u0002",
        weightsB64: "AAAAAAAAAABm////////IgAAALtEAAAAAAAAu0QAAAAAAAC7RAAAAAAAALtEAAAAAAAAu0QAAAAAAAC7RAAAAAAAALtEAAAAAAAAu0QAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "U",
        width: 9,
        anchorKey: "\u0000\u0000\u0100\u0200\u0200\u0200\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEALtEAAAAALtEAIhmAAAAALsiAET/AAAAZrsAAABE////uwAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "V",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\u0000\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAABmiAAAAAC7IiK7AAAAIrsAALsiAABmZgAAZmYAALsiAAAiuwAiuwAAAAC7ImZmAAAAAGZEuyIAAAAAIoi7AAAAAAAAu2YAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "W",
        width: 11,
        anchorKey: "\u0000\u0000\u0080\u0200\u0000\u0002\u0000\u0000\u0200\u0000\u0002",
        weightsB64: "AAAAAAAAAAAAAABEiAAAAP+IAAAA/yK7AAAiiLsAACK7ALsiAGZmuyIAZmYAiEQAiCJmRACIRABmZgC7AESIALsAACKIIogAALsiuwAAAP9EZgAAu0RmAAAAiLsiAABmu0QAAABm/wAAAET/AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "X",
        width: 7,
        anchorKey: "\u0000\u0002\u0080\u0000\u0000\u0000\u0200",
        weightsB64: "AAAAAAAAAAAi/yIAAES7AABEiAAAuyIAAAC7ImZmAAAAACKIuwAAAAAAALuIAAAAAABmZrsiAAAAAP8ARLsAAACIRAAAu0QAZrsAAAAi/yIAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Y",
        width: 7,
        anchorKey: "\u0000\u0002\b \u0000\u0000\u0002",
        weightsB64: "AAAAAAAAAGb/AAAARP8Au2YAALtEAET/AES7AAAAiGa7IgAAACL/iAAAAAAAu0QAAAAAALtEAAAAAAC7RAAAAAAAu0QAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "Z",
        width: 7,
        anchorKey: "\u0000\u0302\u0282\u0222\u0212\u0202\u0200",
        weightsB64: "AAAAAAAAAAD//////7sAAAAAALtmAAAAAGa7AAAAACL/IgAAAAD/RAAAAACIiAAAAABE/wAAAAAA/yIAAAAAZv///////wAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "[",
        width: 3,
        anchorKey: "\u0000\u0ffe\u0802",
        weightsB64: "AAAAAAD//yIA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA/wAAAP8AAAD/AAAA//8i",
    },
    {
        char: "\\",
        width: 3,
        anchorKey: "\u0000\b\u0080",
        weightsB64: "AAAAAGZmAABEiAAAAP8AAAC7IgAAZmYAAESIAAAA/wAAALsiAABmZgAAAAAAAAAA",
    },
    {
        char: "]",
        width: 3,
        anchorKey: "\u0000\u0802\u0000",
        weightsB64: "AAAAZv+IAESIAESIAESIAESIAESIAESIAESIAESIAESIZv+I",
    },
    {
        char: "^",
        width: 5,
        anchorKey: "\u0000\u0010\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAALtEAABEiIgAAIhEuwAA/wBmRESIAES7AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "_",
        width: 7,
        anchorKey: "\u0000\u0800\u0800\u0800\u0800\u0800\u0800",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALv///////9m",
    },
    {
        char: "`",
        width: 4,
        anchorKey: "\u0000\u0002\u0000\u0000",
        weightsB64: "AAAAAAD/RAAAIrsAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "a",
        width: 7,
        anchorKey: "\u0000\u0000\u0200\u0248\u0248@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC7//+IAACIZgAAu0QAAAAAAIhEAABE////RACIiAAAu0QAu0QAALtmACL///+IiAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "b",
        width: 7,
        anchorKey: "\u0000\u0000\u0110\u0208\u0208\u0000\u0000",
        weightsB64: "AAAAAAAAAABEiAAAAAAARIgAAAAAAESI//+IAABE/yIAu0QARIgAAESIAERmAABEiABEiAAAZogARP8AALtEAESI//9mAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "c",
        width: 6,
        anchorKey: "\u0000\u0000\u0000\u0208\u0208\u0010",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACI//9mAABmiAAA/yIAu0QAAAAAALsiAAAAAAC7RAAAAAAAZogAALtEAACI//9mAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "d",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\u0208\u0208\u0110\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAZogAAAAAAGaIAACI//+IiABEuwAA/4gAiEQAAGaIALtEAABEiACIRAAAZogARLsAAP+IAABm//+IiAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "e",
        width: 7,
        anchorKey: "\u0000\u0000@\u0248\u0248\u0150\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACI//9EAABEuwAi/wAAiGYAAIhEAIj/////ZgCIRAAAAAAARLsAAP8iAACI//9mAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "f",
        width: 3,
        anchorKey: "\u0000\b\n",
        weightsB64: "AAAAAABm/7sAu0QAiP//ZgC7RAAAu0QAALtEAAC7RAAAu0QAALtEAAAAAAAAAAAA",
    },
    {
        char: "g",
        width: 7,
        anchorKey: "\u0000\u0000\u0800\u0a08\u0a08\u0110\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACI//+IZgBEuwAA/2YAiEQAAGZmALsiAABmZgCIRAAAZmYARLsAAP9mAACI//9mZgAAAAAAu0QAZv///2YA",
    },
    {
        char: "h",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\b\b\u0010\u0000",
        weightsB64: "AAAAAAAAAAC7RAAAAAAAu0QAAAAAALuI//+IAAC7uwAA/yIAu0QAALtEALtEAAC7RAC7RAAAu0QAu0QAALtEALtEAAC7RAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "i",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAALtEAAAAALtEALtEALtEALtEALtEALtEALtEAAAAAAAA",
    },
    {
        char: "j",
        width: 3,
        anchorKey: "\u0800\u0800\u0000",
        weightsB64: "AAAAAGZmAAAAAGZmAGZmAGZmAGZmAGZmAGZmAGZmAIhm//8i",
    },
    {
        char: "k",
        width: 6,
        anchorKey: "\u0000\u0000\u0000\u0000\u0000\b",
        weightsB64: "AAAAAAAAAABmZgAAAAAAZmYAAAAAAGZmAGb/IgBmZkS7AAAAZru7AAAAAGa7iCIAAABmZiK7AAAAZmYAZmYAAGZmAAC7RAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "l",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAALtEALtEALtEALtEALtEALtEALtEALtEALtEAAAAAAAA",
    },
    {
        char: "m",
        width: 11,
        anchorKey: "\u0000\u0000\u0010\b\b\u0000\u0010\b\b\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGZm//+7AP//uwAAZv8AALv/AAC7RABmZgAAZmYAAIhmAGZmAABmZgAAiGYAZmYAAGZmAACIZgBmZgAAZmYAAIhmAGZmAABmZgAAiGYAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "n",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\b\b\u0010\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAALtm//+IAAC7uwAA/yIAu0QAALtEALtEAAC7RAC7RAAAu0QAu0QAALtEALtEAAC7RAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "o",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\u0208\u0208\u0110\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACI//9EAABEuwAA/yIAiEQAAIhmALtEAABmZgCIRAAAiGYARLsAAP8iAACI//9EAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "p",
        width: 7,
        anchorKey: "\u0000\u0000\u0110\u0208\u0208\u0110\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAIhm//9mAACI/yIA/0QAiIgAAGZmAIhmAABEiACIZgAAZmYAiP8AAP8iAIiI//9mAACIZgAAAAAAiGYAAAAA",
    },
    {
        char: "q",
        width: 7,
        anchorKey: "\u0000\u0000\u0000\u0208\u0208\u0110\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAACI//9mZgBmuwAi/2YAiEQAAIhmALsiAABmZgCIRAAAiGYARLsAIv9mAACI//+IZgAAAAAAiGYAAAAAAIhm",
    },
    {
        char: "r",
        width: 4,
        anchorKey: "\u0000\u0000\u0000\b",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAALuI/0QAu4gAAAC7RAAAALtEAAAAu0QAAAC7RAAAALtEAAAAAAAAAAAAAAAA",
    },
    {
        char: "s",
        width: 7,
        anchorKey: "\u0000\u0100\u0208\u0248\u0248\u0190\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD///9EAACIRAAi/wAAiGYAAAAAAAC7//9mAAAAAAAA/yIA/yIAAP8iAET///9EAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "t",
        width: 3,
        anchorKey: "\u0000\b\u0208",
        weightsB64: "AAAAAAC7RAAAu0QAiP//RAC7RAAAu0QAALtEAAC7RAAAu0QAAGb/RAAAAAAAAAAA",
    },
    {
        char: "u",
        width: 7,
        anchorKey: "\u0000\u0000\u0200\u0200\u0000\u0100\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAALtEAAC7RAC7RAAAu0QAu0QAALtEALtEAAC7RAC7RAAAu0QAiGYAIv9EACL//7uIRAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "v",
        width: 5,
        anchorKey: "\u0000\u0000\u0100\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAuyIAAGZmZmYAALsiIrsAIrsAALsiZmYAAGZmuyIAACL/uwAAAAC7ZgAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "w",
        width: 9,
        anchorKey: "\u0000\u0000\u0100\u0000\u0010 \u0300\u0080\b",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZogAALtmAAD/IiK7ACL/iAAiuwAAuyJEZv8AZmYAAIhEiES7RIhEAABEiLsAZmb/AAAAAP+7ACL/iAAAAAC7ZgAA/0QAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
    {
        char: "x",
        width: 5,
        anchorKey: "\u0000\u0000 \u0080\u0208",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAARLsAIv8AAIhEiEQAACL/uwAAAAC7ZgAAAESI/wAAALsiZmYAZogAAP8iAAAAAAAAAAAAAAAA",
    },
    {
        char: "y",
        width: 5,
        anchorKey: "\u0000\u0800\u0000\u0000\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAARIgAALsiALsAALsAAIgiRGYAAGZmiCIAACKIuwAAAAC7ZgAAAABmRAAAAAC7AAAAIv9mAAAA",
    },
    {
        char: "z",
        width: 5,
        anchorKey: "\u0000\u0208\u0208\u0208\u0208",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAARP////8AAAAAZmYAAAAiuwAAAAC7IgAAAGZmAAAAIrsAAAAAiP////+7AAAAAAAAAAAAAAAA",
    },
    {
        char: "{",
        width: 4,
        anchorKey: "\u0000\u0000\u0000\u0802",
        weightsB64: "AAAAAAAAu/8AIrsAACK7AAAiuwAAZogAZmYAAABmiAAAIrsAACK7AAAiuwAAALv/",
    },
    {
        char: "|",
        width: 3,
        anchorKey: "\u0000\u0000\u0000",
        weightsB64: "AAAAAIhEAIhEAIhEAIhEAIhEAIhEAIhEAIhEAIhEAIhEAIhE",
    },
    {
        char: "}",
        width: 4,
        anchorKey: "\u0000\u0802\u00a0\u0000",
        weightsB64: "AAAAAET/ZgAAIrsAACK7AAAiuwAAAP8iAAAAuwAA/yIAIrsAACK7AAAiuwBE/2YA",
    },
    {
        char: "~",
        width: 7,
        anchorKey: "\u0000\u0000  @@\u0000",
        weightsB64: "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZv//AACIImYARP//IgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
    },
];
//# sourceMappingURL=glyph_atlas_black_on_white_bgr.js.map